<div [ngClass]="isCurrentTab == tabs.Module ? 'tab-pane fade show active' : 'tab-pane fade'" id="module-tab-pane" role="tabpanel" aria-labelledby="module-tab" tabindex="0">
  <div *ngIf="showForm">
    <div class="content-box" [formGroup]="moduleForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="">
            <span class="black-text fs-14 mb-1">Module Name</span>
            <input type="text" [required]="true" formControlName="moduleName" class="form-control"
              [class.is-invalid]="moduleForm.controls['moduleName'].invalid && moduleForm.controls['moduleName'].touched"/>
            <div *ngIf="(moduleForm.controls['moduleName'].invalid && moduleForm.controls['moduleName'].touched) || moduleForm.controls['moduleName'].dirty">
              <small *ngIf="moduleForm.controls['moduleName'].errors?.['required']" class="text-danger fs-13">Module Name is required</small>
            </div>
          </div>
          <div class="" (click)="checkIfDataExists(moduleControls.SubCategory)">
            <span class="black-text fs-14 mb-1">Analytics Toolkit</span>
            <mat-form-field>
              <mat-select required formControlName="subCategories" multiple (selectionChange)="onSubCategoryChange($event)"
              [class.is-invalid]="moduleForm.controls['subCategories'].invalid && moduleForm.controls['subCategories'].touched">
                <mat-select-trigger>
                  <span class="chip-list-head">Added Items:</span>

                  <span class="chip-main">
                   
                    <span 
                    class="chip-list toolkit-display" 
                    style="display: inline-block;margin-left: 0.25em;font-size: 0.8em;" 
                    *ngFor="let subCategoryValue of moduleForm.controls['subCategories'].value" 
                            class="chip-list toolkit-display" 
                            title="{{subCategoryValue.subCategoryName}}">
                      <label class="toolkit-display"  >
                        <mat-icon style="font-size: 1.8em;" *ngIf="subCategoryValue.subCategoryDisplayName!=null">short_text</mat-icon>
                        <span class="toolkit-display-text" *ngIf="subCategoryValue.subCategoryDisplayName!=null">{{subCategoryValue.subCategoryDisplayName}}</span>
                        <span class="toolkit-display-name">{{subCategoryValue.subCategoryName}}</span>
                      </label>
                      <a class="close"(click)="$event.stopPropagation();$event.preventDefault();removeSubCategory(subCategoryValue)">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </a>
                    </span>
                  </span>
                  @if ((moduleForm.controls['subCategories'].value?.length || 0) > 0) {
                  <span class="chip-list count" (click)="$event.stopPropagation();$event.preventDefault();previewPopup(moduleControls.SubCategory, undefined)">
                    #{{(moduleForm.controls['subCategories'].value?.length)}}
                  </span>
                  }
                </mat-select-trigger>
                @for (rg of this.subCategoryGroups ; track rg) {
                  
                  @if(rg.groupName==null){
                     @for (subCategory of rg.items; track subCategory) {
                        <mat-option  [value]="subCategory">{{subCategory.subCategoryName}}
                          <em>{{subCategory.subCategoryDisplayName}}</em>
                        </mat-option>
                      }
                  }
                  @else{
                    
                      @for (subCategory of rg.items; track subCategory) {
                        <mat-option class="theme-text multiline" [value]="subCategory">

                          <label class="toolkit-display">
                            <mat-icon >short_text</mat-icon>
                            <span class="toolkit-display-text">{{subCategory.subCategoryDisplayName}}</span>
                            <span class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
                          </label>
                        </mat-option>
                      }
                  }
                }
              </mat-select>
            </mat-form-field>
            <div *ngIf="(moduleForm.controls['subCategories'].invalid && moduleForm.controls['subCategories'].touched) || moduleForm.controls['subCategories'].dirty">
              <small *ngIf="moduleForm.controls['subCategories'].errors?.['required']" class="text-danger fs-13">Analytics Toolkit is required</small>
            </div>
          </div>
          <div class="mb-2" (click)="checkIfDataExists(moduleControls.Metrics)">
            <span class="black-text fs-14 mb-1">Metric</span>
            <mat-form-field>
              <mat-select required formControlName="metrics" multiple
              [class.is-invalid]="moduleForm.controls['metrics'].invalid && moduleForm.controls['metrics'].touched">
                <mat-select-trigger>
                  <span class="chip-list-head">Added Items:</span>
                  <span class="chip-main">
                    <span *ngFor="let metricValue of moduleForm.controls['metrics'].value" class="chip-list">{{metricValue.metricName}}
                      <a class="close" (click)="$event.stopPropagation();$event.preventDefault();removeMetric(metricValue)">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 1L1 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M1 1L9 9" stroke="#4F6681" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </a>
                    </span>
                  </span>
                  @if ((moduleForm.controls['metrics'].value?.length || 0) > 0) {
                  <span class="chip-list count" (click)="$event.stopPropagation();$event.preventDefault();previewPopup(moduleControls.Metrics, undefined)">
                    #{{(moduleForm.controls['metrics'].value?.length || 0)}}
                  </span>
                  }
                </mat-select-trigger>
                @for (metric of metrics; track metric) {
                  <mat-option [disabled]="isEdit" [value]="metric">{{metric.metricName}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div *ngIf="(moduleForm.controls['metrics'].invalid && moduleForm.controls['metrics'].touched) || moduleForm.controls['metrics'].dirty">
              <small *ngIf="moduleForm.controls['metrics'].errors?.['required']" class="text-danger fs-13">Metrics is required</small>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="sticky-btns">
      <div class="row">
        <div class="col-sm-12 text-right">
          <button type="button" class="btn theme-btn-outline px-5" (click)="closeCreateForm()">Cancel</button>
          <button type="button" class="btn theme-btn px-4 ms-3" [disabled]="moduleForm.invalid" (click)="createModule()">{{ isEdit ? "Update" : "Create" }}</button>
        </div>
      </div>
    </div>
  </div>
   <div *ngIf="modules.length && !showForm" class="table-responsive tab-table data-management-table">
    <table aria-describedby="This table describes the module information" class="table table-hover data-grid">
       <thead class="data-module-header">
         <tr>
           <th class="serialNo-header">S.No</th>
           <th class="firstName-header">Module Name
            <mat-icon *ngIf="sortModuleNameAsc" (click)="sortModuleNameAsc=false; getAllModules('moduleName','asc')">arrow_upward</mat-icon>
            <mat-icon *ngIf="!sortModuleNameAsc" (click)="sortModuleNameAsc=true; getAllModules('moduleName','desc')">arrow_downward</mat-icon>
           </th>
           <th class="component-header">Analytics Toolkit</th>
           <th class="component-header">Metric</th>
           <th class="sticky-right action-header">Action</th>
         </tr>
       </thead>
       <tbody>
         <tr *ngFor="let module of modules; index as i">
           <td>{{i+1}}</td>
           <td><p class="mat-account-detail mb-0" [matTooltip]="module.moduleName">
              {{module.moduleName}}</p></td>
           <td>
             <div class="d-flex">
              <ul class="added-view-package-cell">
               <li *ngFor="let subCategory of module.subCategories?.slice(0,2)" class="list fs-12 toolkit-display">
                @if(subCategory.subCategoryDisplayName==null){
                    <label class="toolkit-display" >
                      <span  class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
                    </label>
                }
                @else {
                  <label class="toolkit-display">
                    <span class="toolkit-display-text"><mat-icon >short_text</mat-icon>{{subCategory.subCategoryDisplayName}}</span>
                    <span class="toolkit-display-name">{{subCategory.subCategoryName}}</span>
                  </label>
                }
               
              </li>
               </ul>
               <span *ngIf="module.subCategories.length > 0" class="badge count fs-12" (click)="previewPopup(moduleControls.SubCategory, module)" >#{{module.subCategories.length}}</span>
             </div>
           </td>
           <td>
            <div *ngIf="module.metrics" class="d-flex">
              <ul class="added-view-package-cell">
                <li *ngFor="let metric of module.metrics?.slice(0,2)" class="list fs-12 toolkit-display">
                
                <label class="toolkit-display" ><span  class="toolkit-display-name">{{metric.metricName}}</span></label>
                  
                </li>
              </ul>
              <span *ngIf="module.metrics.length > 0" class="badge count fs-12" (click)="previewPopup(moduleControls.Metrics, module)">#{{module.metrics.length}}</span>
            </div>
           </td>
           <td class="sticky-right">
             <div class="d-flex align-items-start">
               <div class="form-check form-switch package-switch me-1">
                 <input class="form-check-input" type="checkbox" [(ngModel)]="module.status" role="switch" id="flexSwitchCheckDefault" (click)="activateDeactivateModule(module)">
                 <label class="form-check-label fs-12 mt-1" [ngClass]="!module.status ? 'text-muted' : 'theme-text'" for="flexSwitchCheckDefault"> {{module.status ? "Active" : "Inactive"}} </label>
               </div>
               <a (click)="editModule(module)" class="btn-action" matTooltip="Edit details"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                   <path
                     d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                     stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                     stroke-linejoin="round" />
                   <path d="M9.90845 4.20837C10.2668 6.50837 12.1334 8.26671 14.4501 8.50004" stroke="#5D847B"
                     stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                   <path d="M2.5 18.3334H17.5" stroke="#5D847B" stroke-width="1.5" stroke-miterlimit="10"
                     stroke-linecap="round" stroke-linejoin="round" />
                 </svg></a>
               <a (click)="deleteModule(module)" class="btn-action" matTooltip="Edit details"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4999 1.5C10.9141 1.5 11.2499 1.16421 11.2499 0.75C11.2499 0.335787 10.9141 0 10.4999 0H5.49992C5.0857 0 4.74992 0.335786 4.74992 0.75C4.74992 1.16421 5.0857 1.5 5.49992 1.5L10.4999 1.5ZM1.33325 3.58333H1.44226L2.13845 13.0111L2.13849 13.0117C2.23268 14.2735 3.28338 15.25 4.54891 15.25H11.4489C12.7167 15.25 13.7689 14.2699 13.8595 13.0053L13.8595 13.0051L14.5323 3.58333H14.6666C15.0808 3.58333 15.4166 3.24755 15.4166 2.83333C15.4166 2.41912 15.0808 2.08333 14.6666 2.08333H13.8351L13.8339 2.08333H2.13891L2.13826 2.08333H1.33325C0.919038 2.08333 0.583252 2.41912 0.583252 2.83333C0.583252 3.24755 0.919038 3.58333 1.33325 3.58333ZM3.63433 12.9L2.94634 3.58333H13.0285L12.3633 12.8981C12.3289 13.3784 11.9294 13.75 11.4489 13.75H4.54891C4.06954 13.75 3.6703 13.38 3.63435 12.9003L3.63433 12.9ZM10.4166 7C10.4166 6.58579 10.0808 6.25 9.66658 6.25C9.25237 6.25 8.91658 6.58579 8.91658 7V10.3333C8.91658 10.7475 9.25237 11.0833 9.66658 11.0833C10.0808 11.0833 10.4166 10.7475 10.4166 10.3333V7ZM6.74992 6.25C7.16413 6.25 7.49992 6.58579 7.49992 7V10.3333C7.49992 10.7475 7.16413 11.0833 6.74992 11.0833C6.3357 11.0833 5.99992 10.7475 5.99992 10.3333V7C5.99992 6.58579 6.3357 6.25 6.74992 6.25Z" fill="#5D847B"/>
               </svg></a>
             </div>
           </td>
         </tr>
       </tbody>
     </table>
   </div>
   <mat-paginator *ngIf="modules?.length && !showForm" [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageNumber"
    (page)="changePage($event)" [pageSizeOptions]="[10, 20, 50, 100]">
   </mat-paginator>
   <div *ngIf="!modules.length" class="noDataFound">
    <h1>{{'No Data Found'}}</h1>
  </div>
</div>
